<div class="error-page">
  <h3 class="message">{{message}}</h3>
</div>
